// removed by extract-text-webpack-plugin
module.exports = {"Card":"Card__Card___1saPf","CardFeatured":"Card__CardFeatured___hry0i","CardLink":"Card__CardLink___30OuT","CardOutline":"Card__CardOutline___1tF-I","CardTransparent":"Card__CardTransparent___3DBSg","FirstSection":"Card__FirstSection___1OVAO","FirstSectionContain":"Card__FirstSectionContain___1yEmh","FirstSectionDisclaimer":"Card__FirstSectionDisclaimer___24CfB","SecondSection":"Card__SecondSection___9RK9L","CardWithLink":"Card__CardWithLink___3oGU4","CardAreaContent":"Card__CardAreaContent___3kZBa","ThirdSection":"Card__ThirdSection___34tI6","ThirdSectionLink":"Card__ThirdSectionLink___3gYLD"};


//////////////////
// WEBPACK FOOTER
// ./src/AtomicComponents/Card/Card.less
// module id = 1218
// module chunks = 0 1